import React from 'react';

import { translateComponent } from '@/utils/tolgee/translateComponent';
import { LomavisUpgradeSubscriptionButton1 } from '../LomavisUpgradeSubscriptionButton1';

interface LomavisFeatureAvailable1Props {
  /** The text to display inside the H1 heading */
  title?: string;
  isAvailable: boolean;
  /**
   * Optional content rendered above the gated area in both states.
   * Use this to keep feature info / marketing copy visible even when
   * the feature is locked behind the subscription.
   */
  info?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Atoms: LomavisFeatureAvailable1
 */
export const LomavisFeatureAvailable1: React.FC<
  LomavisFeatureAvailable1Props
> = ({ title, isAvailable, info, children }) => {
  const t = translateComponent('LomavisFeatureAvailable1');

  if (isAvailable) {
    return (
      <>
        {info}
        {children}
      </>
    );
  }

  const heading = title || t('notAvailable');

  return (
    <>
      {info}
      <div className="w-100 d-flex">
        <div
          className="w-100 bg-white rounded p-5 d-flex flex-column gap-5 justify-content-center align-items-center"
          style={{ minHeight: 360 }}
        >
          <h3 className="fs-3 w-50 text-center mb-0">{heading}</h3>
          <div className="d-flex gap-3 justify-content-center">
            <LomavisUpgradeSubscriptionButton1 />
          </div>
        </div>
      </div>
    </>
  );
};
